import { render, staticRenderFns } from "./VenduB2BPage.vue?vue&type=template&id=339aa13a&"
import script from "./VenduB2BPage.vue?vue&type=script&lang=js&"
export * from "./VenduB2BPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports